export function getEmbededTweetMarkup(url) {
  return fetch(url)
    .then(resp => resp.json())
    .then(data => data["html"])
    .catch(error => console.error(error))
}